import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { SelectItem } from "primeng/api";
import { Table } from "primeng/table";
import { Router, ActivatedRoute } from "@angular/router";
import { valorAnd, valorOr, url } from "src/app/config/config";

@Component({
  selector: "app-simple-table",
  templateUrl: "./simple-table.component.html",
  styleUrls: ["./simple-table.component.css"],
})
export class SimpleTableComponent implements OnInit {
  @ViewChild("dt") dt: Table;

  @Input() cols: any;
  @Input() items: any;
  @Input() database: string;
  @Input() url2: string;
  @Input() fieldsOkNok: any;
  @Input() camposOkNada: any;
  @Input() fieldsSi: any;
  @Input() botonesOfOn: any;
  @Input() revisionSalida: boolean;
  @Input() mostrarInformes: boolean;
  @Input() encuestaHigiene: boolean;
  @Input() mostrarOperarioAdd: boolean;
  @Input() showInfo: boolean;
  @Input() showDuplicate: boolean;
  @Input() listarTodos: boolean;
  @Input() discriminadorCampo: string;
  @Input() showPartesEjecucion: boolean;

  @Output() consultarInformes: EventEmitter<any> = new EventEmitter<any>();
  @Output() listarCamposEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeValueRevisionEmmit: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() changeValueEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() infoEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() iniciarEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() duplicateEmmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() mostrarOperarioEmmit: EventEmitter<any> = new EventEmitter<any>();

  @Output() toggleShowPartesEjecucionEmmit: EventEmitter<any> =
    new EventEmitter<any>();

  public oldValue: any;
  public selectedOpciones: string = "pendientes";
  public date2: Date;
  public es: any;
  public expression = false;

  public tiritas: any = [];
  public controlDataUpdate: any = [];
  public displayDialog = false;
  public displayMultiple = false;

  public editControl: any = [];
  public mostrar = false;
  public display: boolean = false;
  // public createTiritasForm:FormGroup;
  public myMonth = "";

  public tiritasInfo: any = [];
  public columnasVisibles: boolean = false;
  public anchoTabla = "1500px";

  public showTables = true;
  public first = 0;
  public mydt: any;

  public buscador: string = "";
  public auxitems: any[];
  public imageFile = url + "upload/resource/file.png";

  public parteEjecucionOptions = [
    { label: "Pendientes", value: "pendientes" },
    { label: "Todos", value: "todos" },
    { label: "Completados", value: "completados" },
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ],
      monthNamesShort: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic",
      ],
      today: "Hoy",
      clear: "Borrar",
    };
    

    this.auxitems = [...this.items];

    this.recuperarPosicion();
    //console.log('this.cols',this.cols,'this.items' ,this.items);
  }

  recuperarPosicion() {
    try {
      this.buscador = localStorage.getItem("buscador");
      this.buscadorEspecial(this.buscador);
      localStorage.removeItem("buscador");
    } catch (error) {
      this.buscador = "";
    }
    try {
      if (this.comprobarSiHayValorDefinido(localStorage.getItem("date"))) {
        this.date2 = new Date(localStorage.getItem("date"));
        this.filtrarFecha(this.date2, this.dt, "fecha");
        localStorage.removeItem("date");
      } else {
      }
    } catch (error) {
      this.date2 = null;
    }
    try {
      if (
        localStorage.getItem("guardar_posicion") !== null ||
        localStorage.getItem("guardar_posicion") !== undefined
      ) {
        this.first = Number(localStorage.getItem("guardar_posicion"));

        localStorage.removeItem("guardar_posicion");
      } else {
        this.first = 0;
      }
    } catch (error) {
      this.first = 0;
    }
  }

  listarCampos() {
    this.listarCamposEmmit.emit();
  }

  consultar(dt) {
    console.log("dt", dt);

    this.consultarInformes.emit(dt);
  }

filtrarFecha(event, dt, col) {
  if (!event) {
    this.dt.filter(null, col, col.filterMatchMode);
  } else {
    const fechaFiltro = this.toDdMmYyyy(event);

    this.items = this.auxitems.map((item: any) => {
      if (item[col]) {
        item[col] = this.toDdMmYyyy(item[col]);
      }
      return item;
    });

    this.dt.filter(fechaFiltro, col, 'equals');
  }

  this.cambios(dt);
}

toDdMmYyyy(fecha: any) {
  if (!fecha) return null;

  if (typeof fecha === 'string' && fecha.indexOf('-') > -1) {
    const partes = fecha.split('-');
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }

  const d = new Date(fecha);
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${dia}/${mes}/${year}`;
}


  cambios(dt) {
    this.mydt = dt;
  }

  checkRole() {
    try {
      if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  checkRevisionTirita() {
    if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
      return true;
    }
    let readonly = "";
    try {
      readonly = localStorage.getItem("readonly");
    } catch (error) {
      readonly = "";
    }
    if (readonly.localeCompare("1") == 0) {
      return false;
    } else {
      return true;
    }
  }

  changeValueRevision(data: any) {
    //console.log('data.revision',data.revision);

    this.changeValueRevisionEmmit.emit(data);
  }

  changeValueCompletado(value: any, index: number) {
    value.completado = value.completado == 0 ? 1 : 0;

    this.changeValueEmmit.emit({
      value,
      index,
    });
  }

  changeValue(value: any, index: number) {
    this.changeValueEmmit.emit({
      value,
      index,
    });
  }

  info(event) {
    this.infoEmmit.emit(event);
  }

  iniciar() {
    this.iniciarEmmit.emit(true);
  }

  update(id, index) {
    //console.log('id', id, 'index', index);

    if (this.comprobarSiHayValorDefinido(this.buscador)) {
      localStorage.setItem("buscador", this.buscador);
    }
    //console.log(this.date2.toString(),this.date2.toTimeString().length);

    try {
      if (this.date2.toTimeString().length >= 1) {
        localStorage.setItem("date", this.date2.toUTCString());
      } else {
      }
    } catch (error) {}
    //console.log('this.dt.first.toString()',this.dt.first.toString());
    localStorage.setItem("guardar_posicion", this.dt.first.toString());
    this.router.navigate(["edit", id], { relativeTo: this.route });
    //this.updateEmmit.emit( event );
  }

  delete(id) {
    this.deleteEmmit.emit(id);
  }

  nuevo() {
    this.router.navigate(["crear"], { relativeTo: this.route });
  }

  duplicate($event) {
    this.duplicateEmmit.emit($event);
  }

  buscadorEspecial(value: string) {
    let baseItems = [...this.auxitems];

    console.log(this.showPartesEjecucion);
    

    if(this.showPartesEjecucion == true){
      if (this.selectedOpciones === 'pendientes') {
        baseItems = baseItems.filter(item => item.completado == 0);
      } else if (this.selectedOpciones === 'completados') {
        baseItems = baseItems.filter(item => item.completado == 1);
      }
    }

    if (value == null || value == undefined || value.trim().length === 0) {
      this.items = [...baseItems];
    } else {
      const texto = value.trim();

      if (texto.includes(valorAnd)) {
        const valores = texto
          .split(valorAnd)
          .map((v) => v.trim())
          .filter((v) => this.comprobarSiHayValorDefinido(v) && v.length > 0);

        let resultado = [...baseItems];

        for (const termino of valores) {
          resultado = this.buscadorSimple(termino, resultado);
        }

        this.items = this.quitarDuplicados(resultado);
      } else if (texto.includes(valorOr)) {
        const valores = texto
          .split(valorOr)
          .map((v) => v.trim())
          .filter((v) => this.comprobarSiHayValorDefinido(v) && v.length > 0);

        this.items = this.quitarDuplicados(
          this.buscadorCompuesto(valores, baseItems),
        );
      } else {
        this.items = this.quitarDuplicados(
          this.buscadorSimple(texto, baseItems),
        );
      }
    }

    this.mydt = this.dt;
  }

  buscadorSimple(value: string, itemsBase: any[]) {
    const textoBuscado = value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    const items = [];

    for (const item of itemsBase) {
      for (const key in item) {
        if (this.comprobarSiHayValorDefinido(item[key])) {
          const textoCampo = item[key]
            .toString()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

          if (textoCampo.includes(textoBuscado)) {
            items.push(item);
            break; // evita meter el mismo item varias veces por distintas propiedades
          }
        }
      }
    }

    console.log(items);
    

    return items;
  }

  buscadorCompuesto(values: string[], itemsBase: any[]) {
    const textosBuscados = values.map((v) =>
      v
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, ""),
    );

    const items = [];

    for (const item of itemsBase) {
      for (const key in item) {
        if (this.comprobarSiHayValorDefinido(item[key])) {
          const textoCampo = item[key]
            .toString()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

          if (textosBuscados.some((texto) => textoCampo.includes(texto))) {
            items.push(item);
            break; // evita duplicados por varias columnas
          }
        }
      }
    }

    return items;
  }

  comprobarSiHayValorDefinido(value): boolean {
    if (value == null || value == undefined || value.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  quitarDuplicados(etiquetas: any[]) {
    let item = [];
    let discriminador = true;
    for (let index = 0; index < etiquetas.length; index++) {
      etiquetas[index].id;
      for (let index2 = 0; index2 < item.length; index2++) {
        if (item[index2].id == etiquetas[index].id) {
          discriminador = false;
        } else {
          discriminador = true;
        }
      }
      if (discriminador) {
        item.push(etiquetas[index]);
      } else {
        discriminador = true;
      }
    }
    return item;
  }

  comprobarFilaValor(columna: string, valor: string): string {
    try {
      if (this.fieldsOkNok != null && this.fieldsOkNok.length >= 1) {
        if (this.fieldsOkNok.includes(columna)) {
          if (valor == "1") {
            return "OK";
          } else {
            return "NOK";
          }
        }
      }
      if (this.camposOkNada != null && this.camposOkNada.length >= 1) {
        if (this.camposOkNada.includes(columna)) {
          if (valor == "1") {
            return "OK";
          } else {
            return "";
          }
        }
      }
      if (this.fieldsSi != null && this.fieldsSi.length >= 1) {
        if (this.fieldsSi.includes(columna)) {
          if (valor == "1") {
            return "SÍ";
          } else {
            return "NO";
          }
        }
      }

      return valor;
    } catch (error) {
      return valor;
    }
  }

  comprobarCalidad(data: any) {
    // console.log(data);

    let result = new Array();
    let myRespuesta = "";
    /* global_gap
    IGP
    prod_integrado
    residuo */
    if (
      data.global_gap !== null &&
      data.global_gap !== undefined &&
      data.global_gap.localeCompare("1") == 0
    ) {
      result.push("Global gap");
    }
    if (
      data.IGP !== null &&
      data.IGP !== undefined &&
      data.IGP.localeCompare("1") == 0
    ) {
      result.push("IGP");
    }
    if (
      data.prod_integrado !== null &&
      data.prod_integrado !== undefined &&
      data.prod_integrado.localeCompare("1") == 0
    ) {
      result.push("Producción integrada");
    }
    if (
      data.residuo !== null &&
      data.residuo !== undefined &&
      data.residuo.localeCompare("1") == 0
    ) {
      result.push("Residuo 0");
    }

    if (result.length == 0) {
      return myRespuesta;
    } else {
      return (myRespuesta = result.toString());
    }
  }
  comprobarDiscriminador(value) {
    // console.log('comporobar discriminador', value[this.discriminadorCampo]);
    // console.log('comporobar discriminador', this.discriminadorCampo);

    if (this.comprobarSiHayValorDefinido(this.discriminadorCampo)) {
      if (this.comprobarSiHayValorDefinido(value[this.discriminadorCampo])) {
        if (
          (value[this.discriminadorCampo] as string).localeCompare(
            "00/00/0000",
          ) == 0 ||
          (value[this.discriminadorCampo] as string).localeCompare(
            "00-00-0000",
          ) == 0
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  comprobarNuevaDiferencia(value) {
    let resultado = "";
    try {
      resultado = JSON.parse(value);
    } catch (error) {}
    return resultado;
  }

  viewDocument(value): string {
    let url = "";
    try {
      if (value.length > 2) {
        url = this.url2 + value;
      } else {
        url = "";
      }
    } catch (error) {
      url = "";
    }
    return url;
  }

  mostrarOperario() {
    this.mostrarOperarioEmmit.emit();
  }
  getDocumentCertificado(archivo) {
    return this.url2 + archivo;
  }

  verHigiene() {
    window.open(
      "https://www.traza-brio.com/calidad/ws/upload/encuesta_higiene/P.02%20Anexo%20V%20-%20Encuesta%20de%20Higiene%20-%20Rev.01%2015.01.19.docx",
      "_blank",
    );
  }

  checkRoleRead() {
    try {
      if (localStorage.getItem("readonly").localeCompare("1") == 0) {
        return false;
      }
    } catch (error) {}

    if (localStorage.getItem("role").localeCompare("ROLE_ADMIN") == 0) {
      return true;
    }
    if (localStorage.getItem("role").localeCompare("ROLE_USER") == 0) {
      return true;
    }
  }

  toggleShowParteEjecucion() {
    this.toggleShowPartesEjecucionEmmit.emit(this.selectedOpciones);

    setTimeout(() => {
      this.buscadorEspecial(this.buscador);
    }, 200);
  }
}
